module.exports = __webpack_public_path__ + "static/media/banesco-mobile-logo.44c523e8.svg";